import React, { Component } from "react"
import { Switch } from "react-router-dom"
import Objectives from "./Objectives"
import '../../design-tokens/index.css'; // Design tokens base styles
import "../../assets/css/gamification2026/index.scss"
import { default as Route } from "../../routes/CustomRoute"
import Home from "./Home"
import Catalog from "./Catalog"
import UtilityInfo from "./UtilityInfo"
import Profile from "./Profile"
import ShoppingCart from "./ShoppingCart"
import News from "./Announcement"
import Page from "./Page"
import Accelerators from "./Accelerators"
import CampaignDashboad from "./CampaignPages";
import SupportingDocuments from "./SupportingDocuments"
import Quiz from "./Quiz"
import Rankings from "./Rankings"
import Analytics from "./Analytics"
import BonusPoints from "./BonusPoints"
import Wallet from "./Wallet"
import Voucher from "./Voucher"
import CustomizedPages from "./CustomizedPages"
import Terms from './Terms'
import { CampaignService, ChatService } from "./normalizer"
import GamificationLayout from "./shared/Layout"

import SaleAttribution from "./SaleAttribution"
import SaleTrade from "./SaleTrade"
import InvoiceContainer from "./Invoice"
import WishList from "./WishList"

export default class Gamification2026Template extends Component {
  state = {
    features: [],
    requested: false,
    hasError: false,
  }

  fetchFeatures(clientSlug, campaignSlug) {
    CampaignService.getFeatures({ clientSlug, campaignSlug })
      .then(response => {
        const { features } = response.data

        const hasChatFeature = features.find(feature => feature.name === "Chat")
        if (hasChatFeature) ChatService.createChatTag("ze-snippet")

        this.setState({ features: features, requested: true })
      })
      .catch(e => {
        this.setState({ requested: true })
      })
  }

  toRender = route => {
    return this.state.features.find(
      f => f.name.toLowerCase() === route.toLowerCase()
    )
  }

  features = () => { return this.state.features }

  /**
   * Called by React during the render phase when a descendant throws.
   * Must be a static method — it returns the state update that causes the
   * component to re-render with the fallback UI.
   */
  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  /**
   * Called by React during the commit phase after getDerivedStateFromError.
   * Used for side-effects (logging, error-reporting) only — never setState here
   * unless for circuit-breaker logic like ErrorBoundary.js.
   */
  componentDidCatch(error, errorInfo) {
    const { rollbar } = window
    if (rollbar && rollbar.error) {
      window.rollbar.error(error, { componentStack: errorInfo && errorInfo.componentStack })
    }
  }

  componentDidMount() {
    const { slug, campaign } = this.props
    this.fetchFeatures(slug, campaign.slug)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.campaign !== this.props.campaign) {
      const { slug, campaign } = this.props
      this.fetchFeatures(slug, campaign.slug)
    }
  }

  render() {
    const { client, campaign, campaignUser, slug, fontFamily } = this.props

    if (this.state.hasError) {
      return (
        <div className="gl-error-fallback" style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <p>Please refresh the page or contact support if the problem persists.</p>
          <button onClick={() => this.setState({ hasError: false })}>Try again</button>
        </div>
      );
    }

    return (
      <GamificationLayout 
        toRender={this.toRender} 
        campaign={campaign} 
        fontFamily={fontFamily}
        client={client}
        features={this.features()}
      >
        <Switch>
          <Route
            exact
            path="/"
            component={Home}
            campaign={campaign}
            slug={slug}
            toRender={this.toRender}

          />
          <Route
            path="/catalog"
            component={Catalog}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/utility-info"
            component={UtilityInfo}
            campaign={campaign}
          />
          <Route 
            path="/terms" 
            component={Terms}
          />
          <Route
            path="/profile"
            component={Profile}
            client={client}
            campaign={campaign}
            slug={slug}
            toRender={this.toRender}
          />
          <Route
            path="/cart"
            component={ShoppingCart}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/objectives"
            component={Objectives}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/dashboard"
            component={CampaignDashboad}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/news"
            component={News}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/accelerators"
            component={Accelerators}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/quiz"
            component={Quiz}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/rankings"
            component={Rankings}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/analytics"
            component={Analytics}
            client={client}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/bonus_points"
            component={BonusPoints}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/wallet"
            component={Wallet}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/voucher/:id"
            component={Voucher}
            campaign={campaign}
            slug={slug}
          />
          <Route
            path="/customized_pages"
            component={CustomizedPages}
            campaign={campaign}
            slug={slug}
          />

          <Route
            path="/sale-trading"
            component={SaleTrade}
            campaign={campaign}
          />
          <Route
              path="/sale-attributions"
              component={SaleAttribution}
              campaign={campaign}
              campaignUser={campaignUser}
            />
            <Route
              path="/supporting-documents/:slug"
              component={SupportingDocuments}
            />
            <Route path="/page/:slug" component={Page} />
            {this.toRender("Invoice") && (
              <Route
                path="/invoice"
                component={InvoiceContainer}
                campaign={campaign}
                slug={slug}
              />
            )}
            <Route
              path="/wishlist"
              component={WishList}
              campaign={campaign}
              slug={slug}
            />
        </Switch>
      </GamificationLayout>
    )
  }
}
